module.exports = __webpack_public_path__ + "static/media/warehouse.b10242e5.png";